import { Link } from "react-router-dom";

const links = [
  { label: "Neutral Rugs", path: "/products/neutral-rugs" },
  { label: "Linen Curtains", path: "/products/linen-curtains" },
  { label: "Beige Sofas", path: "/cozy-corners/best-beige-sofas" },
  { label: "Soft Beige Living Room", path: "/living-room/soft-beige" },
  { label: "Small Apartment Soft Neutrals", path: "/living-room/small-apartment-soft-neutrals" },
];

export default function CBNBottomCTA() {
  return (
    <section className="py-24 bg-[#2C2825]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16 text-center">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-5"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Explore More
        </p>
        <h2
          className="text-white text-3xl md:text-4xl mb-5"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          More Guides for a Calm Home
        </h2>
        <p
          className="text-white/50 text-sm leading-relaxed max-w-lg mx-auto mb-12"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
        >
          Every room deserves the same care and consideration. Explore our other guides.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-14">
          {links.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className="border border-white/20 text-white/70 px-5 py-2.5 rounded-full text-xs tracking-[0.12em] hover:bg-white hover:text-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {link.label}
            </Link>
          ))}
        </div>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-white text-[#2C2825] px-8 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#F5F1E8] transition-all duration-300 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Back to Home
          <span className="w-3 h-3 flex items-center justify-center">
            <i className="ri-arrow-right-line text-[11px]" />
          </span>
        </Link>
      </div>
    </section>
  );
}
